import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects deep links from /contest/:contestId/rules to PlayView with that contest.
 */
export default function ContestRulesRedirect() {
  const { contestId } = useParams<{ contestId: string }>();
  if (!contestId) return <Navigate to="/" replace />;
  return <Navigate to={`/play?contestId=${contestId}`} replace />;
}
